import {createAction, props} from '@ngrx/store';
import {ProductFaceDefaultMeasurements as Entity} from './product-face-default-measurements.model';
import {Criteria} from "../app-store.types";
import {IPage, IResultWithPageInfo, ITableSort} from "../app-store.interfaces";

export const load = createAction(
  '[ProductFaceDefaultMeasurements] Load Entities',
  props<{ criteria?: Criteria, correlationId?: string }>()
);

export const loadSuccess = createAction(
  '[ProductFaceDefaultMeasurements] Load Entities Success',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const loadFailure = createAction(
  '[ProductFaceDefaultMeasurements] Load Entities Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const loadSingleIfNecessary = createAction(
  '[ProductFaceDefaultMeasurements] Load Single Entity if necessary',
  props<{ entityId: number, criteria?: Criteria, correlationId?: string }>()
);

export const loadSingle = createAction(
  '[ProductFaceDefaultMeasurements] Load Single Entity',
  props<{ entityId: number, criteria?: Criteria, correlationId?: string }>()
);

export const loadSingleSuccess = createAction(
  '[ProductFaceDefaultMeasurements] Load Single Entity Success',
  props<{ entity: Entity, correlationId?: string }>()
);

export const loadSingleFailure = createAction(
  '[ProductFaceDefaultMeasurements] Load Single Entity Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const loadPage = createAction(
  '[ProductFaceDefaultMeasurements] Load Paginated Entities',
  props<{ page: IPage, criteria?: Criteria, correlationId?: string }>()
);

export const loadPageSuccess = createAction(
  '[ProductFaceDefaultMeasurements] Load Paginated Entities Success',
  props<{ resultWithPageInfo: IResultWithPageInfo<Entity>, correlationId?: string }>()
);

export const createWithResource = createAction(
  '[UserResource] Create ProductFaceDefaultMeasurements with resource',
  props<{ entity: Entity, file: File, correlationId?: string }>()
);

export const loadPageFailure = createAction(
  '[ProductFaceDefaultMeasurements] Load Paginated Entities Failed',
  props<{ error: Error, correlationId?: string }>()
);

export const create = createAction(
  '[ProductFaceDefaultMeasurements] Create Entity',
  props<{ entity: Entity, correlationId?: string }>()
);

export const clearStore = createAction(
  '[ProductFaceDefaultMeasurements] Clear Store Entity'
);

export const createInStore = createAction(
  '[ProductFaceDefaultMeasurements] Create In Store Entity',
  props<{ entity: Entity }>()
);

export const updateInStore = createAction(
  '[ProductFaceDefaultMeasurements] Update In Store Entity',
  props<{ entity: Entity }>()
);

export const removeInStore = createAction(
  '[ProductFaceDefaultMeasurements] Remove In Store Entity',
  props<{ entity: Entity }>()
);

export const saveStoreChanges = createAction(
  '[ProductFaceDefaultMeasurements] Save store changes',
  props<{ correlationId?: string }>()
);

export const saveStoreChangesSuccess = createAction(
  '[ProductFaceDefaultMeasurements] Save store changes success',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const saveStoreChangesFailure = createAction(
  '[ProductFaceDefaultMeasurements] Save store changes failure',
  props<{  error: Error, correlationId?: string }>()
);

export const createSuccess = createAction(
  '[ProductFaceDefaultMeasurements] Create Entity Success',
  props<{ entity: Entity, correlationId?: string }>()
);

export const createFailure = createAction(
  '[ProductFaceDefaultMeasurements] Create Entity Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const createMany = createAction(
  '[ProductFaceDefaultMeasurements] Create Many Entities',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const createManySuccess = createAction(
  '[ProductFaceDefaultMeasurements] Create Many Entities Success',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const createManyFailure = createAction(
  '[ProductFaceDefaultMeasurements] Create Many Entities Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const update = createAction(
  '[ProductFaceDefaultMeasurements] Update Entity',
  props<{ entity: Entity, correlationId?: string }>()
);

export const updateSuccess = createAction(
  '[ProductFaceDefaultMeasurements] Update Entity Success',
  props<{ entity: Entity, correlationId?: string }>()
);

export const updateFailure = createAction(
  '[ProductFaceDefaultMeasurements] Update Entity Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const updateMany = createAction(
  '[ProductFaceDefaultMeasurements] Update Many Entities',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const updateManySuccess = createAction(
  '[ProductFaceDefaultMeasurements] Update Many Entities Success',
  props<{ entities: Entity[], correlationId?: string }>()
);

export const updateManyFailure = createAction(
  '[ProductFaceDefaultMeasurements] Update Many Entities Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const remove = createAction(
  '[ProductFaceDefaultMeasurements] Remove Entity',
  props<{ entityId: number, correlationId?: string }>()
);

export const removeSuccess = createAction(
  '[ProductFaceDefaultMeasurements] Remove Entity Success',
  props<{ entity: Entity, correlationId?: string }>()
);

export const removeFailure = createAction(
  '[ProductFaceDefaultMeasurements] Remove Entity Failure',
  props<{ error: Error, correlationId?: string }>()
);

export const deselectEntities = createAction(
  '[ProductFaceDefaultMeasurements] Deselect Current Entity'
);

export const setCurrentEntity = createAction(
  '[ProductFaceDefaultMeasurements] Set Current Entity',
  props<{ entity: Entity }>()
);

export const setCurrentEntityId = createAction(
  '[ProductFaceDefaultMeasurements] Set Current Entity Id',
  props<{ entityId: number }>()
);

export const setPaginationSettings = createAction(
  '[ProductFaceDefaultMeasurements] Set Pagination Settings',
  props<{
    page: IPage,
  }>()
);

export const setSortSettings = createAction(
  '[ProductFaceDefaultMeasurements] Set Sort Settings',
  props<{ tableSort: ITableSort }>()
);

export const ProductFaceDefaultMeasurementsActions = {
  loadPage,
  loadPageSuccess,
  loadPageFailure,
  load,
  loadSuccess,
  loadFailure,
  loadSingle,
  loadSingleSuccess,
  loadSingleFailure,
  create,
  createSuccess,
  createFailure,
  createMany,
  createManySuccess,
  createManyFailure,
  update,
  updateSuccess,
  updateFailure,
  updateMany,
  updateManySuccess,
  updateManyFailure,
  remove,
  removeSuccess,
  removeFailure,

  setCurrentEntity,
  setCurrentEntityId,
  deselectEntities,

  setPaginationSettings,
  setSortSettings,

  loadSingleIfNecessary,
  createWithResource,

  createInStore,
  updateInStore,
  removeInStore,
  saveStoreChanges,
  saveStoreChangesSuccess,
  saveStoreChangesFailure,
  clearStore
};
